module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "800px",
      "margin": "10px auto"
    }
  }, [_c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.value.image.mobile || 'https://firebasestorage.googleapis.com/v0/b/mamamia-pwa.appspot.com/o/images%2FAMamamiasStory_Image-01.png129?alt=media&token=15b9cc5d-63c5-49e6-b253-d6a88cba0814'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.caption),
      expression: "value.caption"
    }],
    attrs: {
      "placeholder": "Enter a caption..."
    },
    domProps: {
      "value": (_vm.value.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "caption", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.source),
      expression: "value.source"
    }],
    attrs: {
      "placeholder": "Enter a source..."
    },
    domProps: {
      "value": (_vm.value.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "source", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "selectHolder"
  }, [_c('span', [_vm._v("Decoration Style")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.decorationStyle),
      expression: "value.decorationStyle"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.value, "decorationStyle", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "option-1"
    }
  }, [_vm._v("Standard")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "option-2"
    }
  }, [_vm._v("Stars")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32d5687c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/articleWidgets/imageCircle.vue
// module id = 643
// module chunks = 1